import { Route, Routes } from 'react-router-dom'
import Dashboard from './(pages)/main/page'
import BillOfMaterial from './(pages)/bill-of-materials/page'
import VisitRapport from './(pages)/visit-rapport/page'
import Questionnaire from './(pages)/questionnaire/page'
import Documents from './(pages)/documents/page'

const DashboardPage = () => {
  return (
    <Routes>
        <Route path="/*" element={<Dashboard />}/>
        <Route path="/bill-of-materials/*" element={<BillOfMaterial />}/>
        <Route path="/bezoekrapport/*">
          <Route path="" element={<VisitRapport />}/>
          <Route path="vragenlijst/*" element={<Questionnaire />}/>
        </Route>
        <Route path="/documents/*" element={<Documents />}/>
    </Routes>
  )
}

export default DashboardPage